/**
 * @generated SignedSource<<146f014633927f394ddf960a506da573>>
 * @relayHash 7c8317bb717346ea2ddd7f2fdb49f2d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7

import type { ConcreteRequest } from 'relay-runtime';
export type InvokeExtensionInput = {
  async?: boolean | null;
  contextIds: ReadonlyArray<string>;
  entryPoint?: string | null;
  extensionDetails?: ExtensionDetailsInput | null;
  extensionId?: string | null;
  oAuthScopes?: ReadonlyArray<string> | null;
  payload: AGG$JSON;
  productEventScopes?: ReadonlyArray<string> | null;
};
export type ExtensionDetailsInput = {
  definitionId: string;
  extensionKey: string;
};
export type ByLineForgeAppinvokeExtensionMutation$variables = {
  input: InvokeExtensionInput;
};
export type ByLineForgeAppinvokeExtensionMutation$data = {
  readonly invokeExtension: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: string;
        readonly id?: string;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly response: {
      readonly body: AGG$JSON;
    } | null;
    readonly success: boolean;
  } | null;
};
export type ByLineForgeAppinvokeExtensionMutation = {
  response: ByLineForgeAppinvokeExtensionMutation$data;
  variables: ByLineForgeAppinvokeExtensionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InvokeExtensionResponse",
    "kind": "LinkedField",
    "name": "invokeExtension",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "InvocationResponsePayload",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "body"
          }
        ]
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          },
          {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "ScalarField",
                "name": "statusCode"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "BulkMutationErrorExtension"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ByLineForgeAppinvokeExtensionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ByLineForgeAppinvokeExtensionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c8317bb717346ea2ddd7f2fdb49f2d0",
    "id": "4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7",
    "metadata": {},
    "name": "ByLineForgeAppinvokeExtensionMutation",
    "operationKind": "mutation",
    "text": "mutation ByLineForgeAppinvokeExtensionMutation($input:InvokeExtensionInput!){invokeExtension(input:$input){success,response{body},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "00321bd07f93db1aae1039ee5a2af686";

export default node;
